import { useEffect, useState } from 'react';

import { INutrient, IProduct } from '@interfaces';

import BuilderProduct from '@components/common/builder/product';
import { useActiveBoxIndex } from '@app/store/cart.selectors';

export default function BuilderProducts({ category, filterBy, setAddedCallback, processing, isEditing, showUpgradeBoxModal }
    : { category: any, filterBy: string, setAddedCallback: Function, processing: boolean, isEditing: boolean, showUpgradeBoxModal?: Function }
) {
    const activeBoxIndex = useActiveBoxIndex();
    const [products, setProducts] = useState(Object.values(category.products));

    useEffect(() => {
        if (filterBy) {
            let data: IProduct[] = [];

            Object.values(category.products)
                    .filter((p: IProduct) => category.id !== 'peppa' || p.groups.includes('peppa'))
                    .forEach((product: IProduct) => {
                        product.nutrients.forEach((nutrient: INutrient) => {
                            if (nutrient.slug === filterBy) {
                                data[product.id] = product;
                            }
                        });
                    });

            setProducts(data);
            return;
        }

        setProducts(Object.values(category.products));
        return;
    }, [filterBy]);

    return (
        <>
            {products.length > 0
                ?
                <div className={`category ${category.id}`} id={category.id}>
                    <div className="title">
                        <div
                            style={{visibility: 'hidden', position: 'relative', top: -90}}
                            id={`category-${category.id}`}></div>
                        <h2>
                            <span>{category.title}</span>
                            {(category.pricingType && category.pricePerMeal) &&
                                <span>From ${category.pricePerMeal.toFixed(2)} for {category.pricingType}</span>
                            }
                        </h2>
                    </div>
                    <div className="products-row">
                        {products.filter((p: IProduct) => category.id !== 'peppa' || p.groups.includes('peppa'))
                            .sort((a: any, b: any) => a.availability < b.availability ? -1 : (a.availability > b.availability ? 1 : 0))
                            .map((product: IProduct) =>
                                <div key={product.id} className="product-wrapper">
                                    <BuilderProduct
                                        product={product}
                                        pdpNavigation={'modal'}
                                        disabled={activeBoxIndex === null || processing}
                                        setAddedCallback={setAddedCallback}
                                        showUpgradeBoxModal={showUpgradeBoxModal} />
                                </div>
                            )}
                    </div>
                </div>
                :
                <></>
            }
        </>
    );
}
